import Raven from 'raven-js';
import { Metrics } from '../../utils/metrics';
const hasStatusCode = error => {
  return error !== null && ('statusCode' in error || 'status' in error);
};
export const logApiSuccess = context => {
  const tags = {
    query: context.queryName,
    operation: context.operation
  };
  if (context.version) {
    tags.version = context.version;
  }
  Metrics.counter('v2-api-request-success', tags).increment();
};
export const logApiError = (error, context) => {
  var _error$graphQLErrors;
  const networkError = error === null || error === void 0 ? void 0 : error.networkError;
  const statusCode = hasStatusCode(networkError) ? networkError.statusCode || networkError.status : undefined;
  if (networkError && (statusCode === 0 || statusCode === null || statusCode === undefined)) {
    return;
  }
  const errorCode = (error === null || error === void 0 || (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 || (_error$graphQLErrors = _error$graphQLErrors[0]) === null || _error$graphQLErrors === void 0 || (_error$graphQLErrors = _error$graphQLErrors.extensions) === null || _error$graphQLErrors === void 0 || (_error$graphQLErrors = _error$graphQLErrors.code) === null || _error$graphQLErrors === void 0 ? void 0 : _error$graphQLErrors.toString()) || (statusCode ? `HTTP_${statusCode}` : null) || (error === null || error === void 0 ? void 0 : error.message) || 'unknown';
  const metricTags = {
    query: context.queryName,
    operation: context.operation,
    error_type: errorCode
  };
  if (context.version) {
    metricTags.version = context.version;
  }
  Metrics.counter('v2-api-request-error', metricTags).increment();
  const ravenExtra = {
    query: context.queryName,
    operation: context.operation,
    errorCode,
    variables: context.variables
  };
  if (statusCode) {
    ravenExtra.statusCode = statusCode;
  }
  const ravenTags = {
    query_name: context.queryName,
    error_code: errorCode
  };
  if (context.version) {
    ravenExtra.version = context.version;
    ravenTags.api_version = context.version;
  }
  Raven.captureException(new Error(errorCode), {
    extra: ravenExtra,
    tags: ravenTags
  });
};